<script>
  export let data;
</script>

<style>
  .Card {
    background-color: var(--colour-background);
    padding: 20px;
    border-radius: 10px;
    box-shadow: -7px -7px 7px 0 rgba(255, 255, 255, 1),
      7px 7px 7px 0 rgba(0, 0, 0, 0.03);
  }

  h2 {
    font-size: 20px;
    font-family: var(--font-heading);
    font-weight: normal;
    margin: 7.5px 0px;
    padding-bottom: 7.5px;
    border-bottom: 1px solid var(--colour-secondary);
  }

  p {
    margin: 15px 0;
  }

  .section {
    margin: 0 0 15px 0;
  }

  table {
    margin: 0px 15px 15px 0px;
    border-spacing: 10px 5px;
    border-collapse: collapse;
    width: 100%;
  }

  th {
    text-align: left;
    padding: 0;
  }

  tr:nth-child(even) {
    background-color: var(--colour-secondary-l);
  }

  td {
    vertical-align: top;
    padding: 2px 5px;
    min-width: 50px;
  }

  .example .title {
    cursor: pointer;
    margin-bottom: 0px;
    -webkit-user-select: none; /* Chrome all / Safari all */
    -moz-user-select: none; /* Firefox all */
    -ms-user-select: none; /* IE 10+ */
    user-select: none;
  }

  .tags {
    display: flex;
    flex-wrap: wrap;
  }

  .tag {
    /* background-color: var(--colour-secondary); */
    padding: 5px 10px;
    margin-right: 10px;
    margin-bottom: 10px;
    white-space: nowrap;
    border-radius: 20px;
    border: solid 1px var(--colour-secondary);
  }

  .expandable {
    overflow: hidden;
    transition: height 0.3s ease-out;
    height: auto;
    margin-top: 0px;
  }

  .arrow {
    --arrow-size: 6px;
    display: inline-block;
    height: 0;
    width: 0;
    border-top: transparent solid var(--arrow-size);
    border-bottom: transparent solid var(--arrow-size);
    border-left: var(--colour-secondary-l) solid var(--arrow-size);
    margin-right: 5px;
    transition: 0.2s;
    transition-property: transform;
  }

  .arrow.expanded {
    transform: rotate(90deg);
  }
</style>

<div class="Card">
  <h2>{data.title}</h2>
  <p class="section">{data.description}</p>
  {#if data.rakaah}
    <table>
      {#each data.rakaah as rakaat}
        <tr>
          <td>{rakaat.count}</td>
          <td>{rakaat.type}</td>
          <td>{rakaat.detail || ''}</td>
        </tr>
      {/each}
    </table>
  {/if}
</div>
